import React from "react";
import useClientConfig from "../../config/careers/clientConfig";
import JobListings from "./jobListings/JobListings";
import CvmCultureLanding from "./cultureLanding/cvm/CvmCultureLanding";

const CareersLandingGate = () => {
  const { clientSiteSettings } = useClientConfig();

  if (clientSiteSettings?.hasCultureLandingPage) {
    if (clientSiteSettings?.banner === "cvm_banner") {
      return <CvmCultureLanding />;
    }
  }

  return <JobListings />;
};

export default CareersLandingGate;
